// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right_banner_banner_cnt .nav{
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid #0b70b5;
}

.right_banner_banner_cnt .nav .nav-item{
    background: #0b70b5;
    color: #fff;
    font-weight: 600;
    margin: 0 6px;
    border-radius: 10px 10px 0 0;
}
.right_banner_banner_cnt .nav .nav-item .nav-link{
    background: transparent;
    color: inherit;
}

.right_banner_banner_cnt .nav .nav-item .nav-link.active{
    background: #fff;
    color: #000;
    border: 1px solid #0b70b5;
    font-weight: 600;
}

.send_a_certificates{
    padding: 0 20px;
}

.certificate_form{
    position: relative;
}
.user_iconnn{
    position: absolute;
    bottom: 12px;
    left: 10px;
}

.certificate_field{
    padding-left: 40px;
    height: 45px;
    border: 1px solid #0b70b5;
}

.certificate_field:focus{
    box-shadow: none;
}

.certificate_form label{
    font-weight: 600;
}

.travel_editor{
    border: 1px solid #0b70b5;
}
.text_editor{
    margin: 60px 0;
}
.text_editor_heading{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
}
.text_editor_heading h2, .complementary_certificate h2{
    font-size: 22px;
}
.text_editor_heading{
    margin-bottom: 15px;
}
.complementary_certificate h2{
    margin-bottom: 25px;
}
.cus_but{
    border: 1px solid #0b70b5;
    background: #0b70b5;
    border-radius: 10px;
    padding: 0 10px;
    height: 40px;
    color: #fff;
}


.complimentary_inner{
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
}
.image {
    width: 100%;
    height: 200px;
  }
  .image:hover {
    opacity: 1;
  }
  .radio-img{
    width: calc(100%/5);
    padding: 0 10px;
    text-align: center;
    display: block;
    margin-top: 35px;
  }

  .radio-img > input {
    display: none;
  }
  .radio-img > .image {
    cursor: pointer;
    border: 2px solid black;
  }
  .radio-img > input:checked + .image {
    border: 4px solid #0b70b5;
    box-shadow: 0 0 10px rgba(0,0,0,0.8);
    position: relative;
  }
  .radio-img > input:checked + .image:after{
    content: "Selected";
    width: 100%;
    height: 30px;
    background:#0b70b5;
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
    color: #fff;
    font-size: 16px;
    line-height: 30px;
  }
  .image img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .radio-img span{
    background: rgba(0,74,173,0.6);
    margin-bottom: 0px;
    padding: 5px 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    width:100%;
    white-space: nowrap;
    display: block;
    color: #fff;
    font-size: 16px;
  }


  .send_invitation_but{
    margin-top: 100px;
  }
.send_invitation_but{
    display: flex;
    justify-content: center;
    align-items: center;
}
  .send_inv{
    background: #0b70b5;
    border: 0px;
    color: #fff;
    font-size: 18px;
    padding: 10px 30px;
    border-radius: 8px;
  }

  .send_inv span{
    margin-right: 10px;
  }




@media screen and (max-width:1199px){
    .right_banner_banner_cnt .nav .nav-item{
        font-size: 14px;
    }
    .right_banner_banner_cnt .nav .nav-item .nav-link{
        padding: 5px 8px;
    }
    .radio-img{
        width: calc(100%/3);
        margin-bottom: 55px;
    }
}

@media screen and (max-width:991px){
    .right_banner_banner_cnt .nav .nav-item{
        margin-bottom: 25px;
    }
}

@media screen and (max-width:767px){
    .right_banner_banner_cnt .nav .nav-item, .right_banner_banner_cnt .nav .nav-item .nav-link.active{
        width: 100%;
        text-align: center;
    }
    .right_banner_banner_cnt .nav .nav-item .nav-link{
        width: 100%;
        height: 40px;
        text-align: center;
    }
    .radio-img{
        width: calc(100%/2);
    }
}

@media screen and (max-width:420px){
    .cus_but{
        font-size: 12px;
    }
    .radio-img{
        width: calc(100%/1);
    }
    .send_a_certificates h2{
        font-size: 22px;
    }
    .text_editor_heading h2, .complementary_certificate h2{
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/travelcertificates/travelcertificates.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,4BAA4B;AAChC;AACA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB;AACA;IACI,WAAW;IACX,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;;EAGA;IACE,iBAAiB;EACnB;AACF;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;;;;AAKF;IACI;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".right_banner_banner_cnt .nav{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-bottom: 2px solid #0b70b5;\n}\n\n.right_banner_banner_cnt .nav .nav-item{\n    background: #0b70b5;\n    color: #fff;\n    font-weight: 600;\n    margin: 0 6px;\n    border-radius: 10px 10px 0 0;\n}\n.right_banner_banner_cnt .nav .nav-item .nav-link{\n    background: transparent;\n    color: inherit;\n}\n\n.right_banner_banner_cnt .nav .nav-item .nav-link.active{\n    background: #fff;\n    color: #000;\n    border: 1px solid #0b70b5;\n    font-weight: 600;\n}\n\n.send_a_certificates{\n    padding: 0 20px;\n}\n\n.certificate_form{\n    position: relative;\n}\n.user_iconnn{\n    position: absolute;\n    bottom: 12px;\n    left: 10px;\n}\n\n.certificate_field{\n    padding-left: 40px;\n    height: 45px;\n    border: 1px solid #0b70b5;\n}\n\n.certificate_field:focus{\n    box-shadow: none;\n}\n\n.certificate_form label{\n    font-weight: 600;\n}\n\n.travel_editor{\n    border: 1px solid #0b70b5;\n}\n.text_editor{\n    margin: 60px 0;\n}\n.text_editor_heading{\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n}\n.text_editor_heading h2, .complementary_certificate h2{\n    font-size: 22px;\n}\n.text_editor_heading{\n    margin-bottom: 15px;\n}\n.complementary_certificate h2{\n    margin-bottom: 25px;\n}\n.cus_but{\n    border: 1px solid #0b70b5;\n    background: #0b70b5;\n    border-radius: 10px;\n    padding: 0 10px;\n    height: 40px;\n    color: #fff;\n}\n\n\n.complimentary_inner{\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0 -10px;\n}\n.image {\n    width: 100%;\n    height: 200px;\n  }\n  .image:hover {\n    opacity: 1;\n  }\n  .radio-img{\n    width: calc(100%/5);\n    padding: 0 10px;\n    text-align: center;\n    display: block;\n    margin-top: 35px;\n  }\n\n  .radio-img > input {\n    display: none;\n  }\n  .radio-img > .image {\n    cursor: pointer;\n    border: 2px solid black;\n  }\n  .radio-img > input:checked + .image {\n    border: 4px solid #0b70b5;\n    box-shadow: 0 0 10px rgba(0,0,0,0.8);\n    position: relative;\n  }\n  .radio-img > input:checked + .image:after{\n    content: \"Selected\";\n    width: 100%;\n    height: 30px;\n    background:#0b70b5;\n    position: absolute;\n    left: 0;\n    top: 0;\n    text-align: center;\n    color: #fff;\n    font-size: 16px;\n    line-height: 30px;\n  }\n  .image img{\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .radio-img span{\n    background: rgba(0,74,173,0.6);\n    margin-bottom: 0px;\n    padding: 5px 10px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width:100%;\n    white-space: nowrap;\n    display: block;\n    color: #fff;\n    font-size: 16px;\n  }\n\n\n  .send_invitation_but{\n    margin-top: 100px;\n  }\n.send_invitation_but{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n  .send_inv{\n    background: #0b70b5;\n    border: 0px;\n    color: #fff;\n    font-size: 18px;\n    padding: 10px 30px;\n    border-radius: 8px;\n  }\n\n  .send_inv span{\n    margin-right: 10px;\n  }\n\n\n\n\n@media screen and (max-width:1199px){\n    .right_banner_banner_cnt .nav .nav-item{\n        font-size: 14px;\n    }\n    .right_banner_banner_cnt .nav .nav-item .nav-link{\n        padding: 5px 8px;\n    }\n    .radio-img{\n        width: calc(100%/3);\n        margin-bottom: 55px;\n    }\n}\n\n@media screen and (max-width:991px){\n    .right_banner_banner_cnt .nav .nav-item{\n        margin-bottom: 25px;\n    }\n}\n\n@media screen and (max-width:767px){\n    .right_banner_banner_cnt .nav .nav-item, .right_banner_banner_cnt .nav .nav-item .nav-link.active{\n        width: 100%;\n        text-align: center;\n    }\n    .right_banner_banner_cnt .nav .nav-item .nav-link{\n        width: 100%;\n        height: 40px;\n        text-align: center;\n    }\n    .radio-img{\n        width: calc(100%/2);\n    }\n}\n\n@media screen and (max-width:420px){\n    .cus_but{\n        font-size: 12px;\n    }\n    .radio-img{\n        width: calc(100%/1);\n    }\n    .send_a_certificates h2{\n        font-size: 22px;\n    }\n    .text_editor_heading h2, .complementary_certificate h2{\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
